import { useEffect } from 'react'
import { useMatches } from 'react-router-dom'

type TitleHandle = { title?: string }

/**
 * 读取最深层匹配路由的 handle.title 写入 document.title;
 * 无任何 handle.title 时回退为空字符串(每次导航重算,天然重置)。
 */
export function TitleManager() {
  const matches = useMatches()
  const next =
    [...matches]
      .reverse()
      .map((m) => (m.handle as TitleHandle | undefined)?.title)
      .find((t): t is string => Boolean(t)) ?? ''

  useEffect(() => {
    document.title = next
  }, [next])

  return null
}
